import React, { useEffect, useState } from 'react';
import api from '../../../../config/axios';

import GrupoDreModal from './modais/GrupoDre';
import Paginacao from '../../../../components/utils/paginacao';

import { FaPlus, FaEdit, FaFilter, FaTrashAlt, FaArrowLeft, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const GruposDre = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const [gruposDre, setGruposDre] = useState([]);
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroTipoLinha, setFiltroTipoLinha] = useState('');

  const [selectedGrupoDre, setSelectedGrupoDre] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const fetchGruposDre = async (currentPage) => {
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const params = {
        page: currentPage,
        limit: limit,
        nome: filtroNome,
        tipo_linha: filtroTipoLinha
      };

      const response = await api.get('/grupos-dre', { params });

      setGruposDre(response.data.records || []);
      setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
      setTotalRegistros(response.data.totalRegistros || 0);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar os dados. Tente novamente mais tarde.');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchGruposDre(currentPage);
  }, [currentPage]);

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleAddGrupoDre = () => {
    setSelectedGrupoDre(null);
    setIsModalOpen(true);
  };

  const handleEditGrupoDre = (grupoDre) => {
    setSelectedGrupoDre(grupoDre);
    setIsModalOpen(true);
  };

  const handleDeleteGrupoDre = async (grupoDre) => {
    const result = await Swal.fire({
      title: 'Tem certeza?',
      text: `Deseja excluir o grupo DRE "${grupoDre.nome}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir!',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/grupos-dre/${grupoDre.id}`);
        Swal.fire('Excluído!', 'Grupo DRE foi excluído com sucesso.', 'success');
        fetchGruposDre(currentPage);
      } catch (error) {
        Swal.fire('Erro!', error.response.data.message || 'Não foi possível excluir o grupo DRE.', 'error');
      }
    }
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchGruposDre(1);
  };

  const handleLimparFiltros = () => {
    setFiltroNome('');
    setFiltroTipoLinha('');
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedGrupoDre(null);
  };

  const handleGrupoDreAtualizado = () => {
    fetchGruposDre(currentPage);
    handleModalClose();
  };

  const getTipoLinhaLabel = (tipo) => {
    const tipos = {
      'valor': 'Valor',
      'subtotal': 'Subtotal',
      'total': 'Total'
    };
    return tipos[tipo] || tipo;
  };

  const getOperacaoLabel = (operacao) => {
    const operacoes = {
      'soma': 'Soma',
      'subtrai': 'Subtrai',
      'calcula': 'Calcula'
    };
    return operacoes[operacao] || operacao;
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-outline-secondary me-3"
                  onClick={() => navigate('/financeiro/cadastros')}
                  title="Voltar para Cadastros"
                >
                  <FaArrowLeft />
                </button>
                <h4 className="fw-bold mb-0">Grupos DRE</h4>
              </div>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            <div className="col-md-6 col-12">
              <button className="btn btn-outline-primary" onClick={handleAddGrupoDre}>
                <FaPlus /> Adicionar Grupo DRE
              </button>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-3 col-12">
              <label className="form-label fw-bold">Nome</label>
              <input
                type="text"
                autoComplete="off"
                placeholder="Digite o nome do grupo"
                value={filtroNome}
                className="form-control"
                onChange={(e) => setFiltroNome(e.target.value.toUpperCase())}
              />
            </div>
            <div className="col-lg-3 col-12 mt-lg-0 mt-3">
              <label className="form-label fw-bold">Tipo de Linha</label>
              <select
                value={filtroTipoLinha}
                className="form-control"
                onChange={(e) => setFiltroTipoLinha(e.target.value)}
              >
                <option value="">Todos os tipos</option>
                <option value="valor">Valor</option>
                <option value="subtotal">Subtotal</option>
                <option value="total">Total</option>
              </select>
            </div>
            <div className="col-lg-6 col-12 mt-lg-0 mt-3 d-flex align-items-end">
              <div className="d-flex gap-2 w-100 justify-content-end">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleLimparFiltros}
                >
                  Limpar
                </button>
                <button
                  className="btn btn-custom-primary"
                  onClick={handleFiltrar}
                >
                  <FaFilter /> Filtrar
                </button>
              </div>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th className="text-nowrap">Nome</th>
                    <th className="text-nowrap">Ordem</th>
                    <th className="text-nowrap">Tipo de Linha</th>
                    <th>Operação</th>
                    <th className="text-center">Visível</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {gruposDre.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum grupo DRE encontrado.
                      </td>
                    </tr>
                  ) : (
                    gruposDre.map((grupoDre, index) => (
                      <tr key={index}>
                        <td className="text-nowrap">{grupoDre.nome}</td>
                        <td>{grupoDre.ordem}</td>
                        <td className="text-nowrap">
                          <span className={`badge ${grupoDre.tipo_linha === 'valor' ? 'bg-primary' :
                            grupoDre.tipo_linha === 'subtotal' ? 'bg-warning' : 'bg-success'
                            }`}>
                            {getTipoLinhaLabel(grupoDre.tipo_linha)}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${grupoDre.operacao === 'soma' ? 'bg-success' :
                            grupoDre.operacao === 'subtrai' ? 'bg-danger' : 'bg-info'
                            }`}>
                            {getOperacaoLabel(grupoDre.operacao)}
                          </span>
                        </td>
                        <td className="text-center">
                          {grupoDre.visivel ? (
                            <span className="fw-bold">Sim</span>
                          ) : (
                            <span className="fw-bold">Não</span>
                          )}
                        </td>
                        <td className="text-center">
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-custom-secondary btn-sm"
                              onClick={() => handleEditGrupoDre(grupoDre)}
                              title="Editar"
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn btn-custom-secondary btn-sm ms-3"
                              onClick={() => handleDeleteGrupoDre(grupoDre)}
                              title="Excluir"
                            >
                              <FaTrashAlt />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <GrupoDreModal
          grupoDre={selectedGrupoDre}
          onClose={handleModalClose}
          onGrupoDreAtualizado={handleGrupoDreAtualizado}
        />
      )}
    </div>
  );
};

export default GruposDre; 